import { log } from '@hungryroot/o11y';
import { type EvPayload } from './hooks/useSaladShooter';

export function trackNoopCalled() {
  log('salad-shooter-track-noop', {});
}

export function logSaladShooterIngest(url: string, payload: EvPayload) {
  log('salad-shooter-ingest', {
    url,
    data: payload,
  });
}
